import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState, forwardRef } from 'react';
import { SearchFieldDropdown } from './SearchFieldDropdown';
import { TextField } from '../TextField';
import { Typography } from '../Typography';
import { useOnClickOutside } from '../../hooks';
import * as S from './styles';
import { Icon } from '../Icon';
export var SearchField = forwardRef(function (_ref, ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      emptyOptionsMessage = _ref.emptyOptionsMessage,
      inputPlaceholder = _ref.inputPlaceholder,
      floatingLabel = _ref.floatingLabel,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      onSelectOption = _ref.onSelectOption,
      onChange = _ref.onChange,
      next = _ref.next,
      _ref$clearSearchField = _ref.clearSearchField,
      clearSearchField = _ref$clearSearchField === void 0 ? function () {
    return null;
  } : _ref$clearSearchField,
      _ref$hasMore = _ref.hasMore,
      hasMore = _ref$hasMore === void 0 ? false : _ref$hasMore,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      _ref$messageError = _ref.messageError,
      messageError = _ref$messageError === void 0 ? '' : _ref$messageError,
      optionIcon = _ref.optionIcon,
      loading = _ref.loading,
      selectedOptions = _ref.selectedOptions,
      selectedOptionIcon = _ref.selectedOptionIcon,
      _ref$closeOnSelect = _ref.closeOnSelect,
      closeOnSelect = _ref$closeOnSelect === void 0 ? true : _ref$closeOnSelect;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      focusedIndex = _useState4[0],
      setFocusedIndex = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showDropdown = _useState6[0],
      setShowDropdown = _useState6[1];

  var _useState7 = useState(function () {
    var optionFound = options.find(function (option) {
      return (option === null || option === void 0 ? void 0 : option.id) === value;
    });

    if (optionFound) {
      return optionFound.name;
    }

    return '';
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      defaultValue = _useState8[0],
      setDefaultValue = _useState8[1];

  var optionRef = useRef(null);
  var refIsNotFunction = ref && typeof ref !== 'function';
  var inputRef = useRef(refIsNotFunction ? ref.current : null);
  var searchRef = useRef(null);
  useOnClickOutside(searchRef, function () {
    setShowDropdown(false);
    setFocused(false);
    setFocusedIndex(0);
  }); // Efeito para realizar o scroll do menu de opções quando o usuário pressiona as setas para cima e para baixo do teclado

  useEffect(function () {
    if (!optionRef.current) return;
    optionRef.current.scrollIntoView(focusedIndex);
  }, [focusedIndex]); // Efeito para mostrar as opções quando o campo de busca está focado e não tem valor

  useEffect(function () {
    if (focused && !defaultValue) {
      setShowDropdown(true);
    }
  }, [focused, defaultValue]);

  var handleClickClear = function handleClickClear() {
    var _a;

    setDefaultValue('');
    clearSearchField();
    setFocusedIndex(0);
    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  };

  var handleSelection = function handleSelection(selectedOption) {
    if (!selectedOption) return;
    var selectedItem = options.find(function (option) {
      return option.id === selectedOption.id;
    });
    setDefaultValue(selectedItem.name);
    onSelectOption(selectedItem.id);
    if (closeOnSelect) setShowDropdown(false);
  };

  var handleKeyDown = function handleKeyDown(e) {
    var _a;

    var nextIndexCount = focusedIndex;
    var optionsLength = options.length - 1;

    switch (e.key) {
      case 'ArrowDown':
        nextIndexCount = focusedIndex < optionsLength ? focusedIndex + 1 : focusedIndex;
        break;

      case 'ArrowUp':
        nextIndexCount = focusedIndex > 0 ? focusedIndex - 1 : focusedIndex;
        break;

      case 'Escape':
        setShowDropdown(false);
        setFocused(false);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        return;

      case 'Enter':
        handleSelection(options[focusedIndex]);
        setFocused(false);
        return;

      case 'Tab':
        setShowDropdown(false);
        setFocused(false);
        return;

      default:
        return;
    }

    setFocusedIndex(nextIndexCount);
  };

  var handleChange = function handleChange(e) {
    setDefaultValue(e.target.value);
    onChange(e.target.value);
  };

  var handleFocus = function handleFocus() {
    setFocused(true);
    setShowDropdown(true);
  };

  return React.createElement(S.Container, {
    ref: searchRef,
    hasError: hasError
  }, React.createElement(TextField.Root, null, React.createElement(TextField.Input, {
    ref: inputRef,
    floatingLabel: floatingLabel,
    value: defaultValue,
    isFieldFocused: focused,
    onChange: handleChange,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    "aria-autocomplete": "list",
    "aria-controls": "dropdown-menu",
    startIcon: React.createElement(TextField.Icon, null, React.createElement(Icon, {
      name: 'Search',
      height: 18,
      width: 18,
      fill: '#C1C1C1'
    })),
    endIcon: React.createElement(TextField.Clear, {
      handleClearSearchField: handleClickClear,
      visible: !!defaultValue
    })
  })), React.createElement(SearchFieldDropdown, {
    next: next,
    hasMore: hasMore,
    showDropdown: showDropdown,
    ref: optionRef,
    emptyOptionsMessage: emptyOptionsMessage,
    options: options,
    focusedIndex: focusedIndex,
    handleSelection: handleSelection,
    setFocusedIndex: setFocusedIndex,
    optionIcon: optionIcon,
    selectedOptionIcon: selectedOptionIcon,
    selectedOptions: selectedOptions,
    loading: loading
  }), hasError && React.createElement(S.MessageErrorWrapper, null, React.createElement(Typography, {
    variant: 'content3',
    color: 'danger'
  }, messageError)));
});